import * as Constants from './Constants';
import safeGetAttribute from './safeGetAttribute';
import { ResponseData } from './getUrlResponseData';
import { getMailPath, getOrigin } from 'owa-url';
import * as trace from 'owa-trace';
import { INLINEIMAGE_ATTRIBUTE_ORIGINALSRC } from 'owa-inline-image-consts';

// Deeplink to React mail
const DEEPLINK_READ_REACT = 'deeplink/read/';

// Deeplink to MVVM
const DEEPLINK_READ_MVVM = '/owa/?debugJS=true&viewmodel=ReadMessageItem&InternetMessageID=';

export default function logDiagnosticData(
    img: HTMLImageElement,
    error: string,
    responseData?: ResponseData,
    retryCount?: number
) {
    let diagnosticData = 'Please engage nickhu@microsoft.com with below data:\n';

    const itemId = safeGetAttribute(img, Constants.ATTRIBUTE_ITEMID);
    if (itemId) {
        diagnosticData += `Deeplink (React): ${getDeepLinkForItem(itemId, true /* isReact */)}\n`;
    }

    // We also want deeplink to Internet message id as item can move which changes the id.
    // Internet message id does not change even the item is moved
    // Unfortunately deeplink to Internet message id is only supported in MVVM by now
    const inetId = safeGetAttribute(img, Constants.ATTRIBUTE_INETID);
    if (inetId) {
        diagnosticData += `Deeplink (MVVM): ${getDeepLinkForItem(inetId, false /* isReact */)}\n`;
    }

    const src = img.src;
    if (src) {
        diagnosticData += `Src: ${src}\n`;
    }

    const originalSrc = safeGetAttribute(img, INLINEIMAGE_ATTRIBUTE_ORIGINALSRC);
    if (originalSrc) {
        diagnosticData += `OriginalSrc: ${originalSrc}\n`;
    }

    if (responseData) {
        const {
            status,
            contentType,
            detectedFormat,
            first10BytesBase64,
            mimeMatched,
        } = responseData;
        if (status) {
            diagnosticData += `Status: ${status}\n`;
        }
        if (contentType) {
            diagnosticData += `ContentType: ${contentType}\n`;
        }
        if (detectedFormat) {
            diagnosticData += `DetectedFormat: ${detectedFormat}\n`;
        }
        if (first10BytesBase64) {
            diagnosticData += `First10Bytes: ${first10BytesBase64}\n`;
        }
        diagnosticData += `MimeMatch: ${mimeMatched}`;
    }

    if (retryCount && retryCount > 0) {
        diagnosticData += `Retried: ${retryCount}`;
    }

    trace.errorThatWillCauseAlert(`Error loading inline image: ${error}.\n` + diagnosticData);
}

/**
 * NOTE: messageId here refers to item id for React and internet message id for MVVM
 */
export function getDeepLinkForItem(messageId: string, isReact: boolean = true): string {
    let origin = getOrigin();

    if (isReact) {
        // Example of deeplink to item react
        // https://outlook-sdf.office.com/mail/deeplink/read/AAMkADQzNjkxZGU3LWZhZmEtNDk5OC04MmI4LWI4NzkzZjEwNWEyMwBGAAAAAAD0lLm0pKzfT7trU9iqUXBIBwCNJ1ub7y5WTLAqREBftV2pAAB2j74iAAB26TFwWR7IQpPS0rmMZETeAAE8dor%2FAAA%3D
        return origin + getMailPath() + DEEPLINK_READ_REACT + messageId;
    } else {
        // Example to deeplink to item MVVM https://outlook-sdf.office.com/owa/?debugJS=true&viewmodel=ReadMessageItem&InternetMessageID=%3CSN2PR00MB0125DDFF2FE5CACD6612833385920%40SN2PR00MB0125.namprd00.prod.outlook.com%3E
        return origin + DEEPLINK_READ_MVVM + messageId;
    }
}
